<div aria-hidden="true"
     class="td-wb-symbol-logo"
     [ngClass]="{ 'td-wb-symbol-logo--small': isSmallLogo(),
                  'td-wb-symbol-logo--large': isLargeLogo() }">
  <ng-container *ngTemplateOutlet="showLogo() ? logoTemplate : avatarTemplate" />
</div>

<ng-template #logoTemplate>
    <img class="td-wb-symbol-logo__logo"
         [alt]="symbol"
         [src]="getSVGImageUrl(svgString)">
</ng-template>

<ng-template #avatarTemplate>
  <td-wb-avatar [initials]="getInitials()"
                avatarType="logo"
                [avatarSize]="getAvatarSize()" />
</ng-template>
